import { useAxiosPost } from '../hook/useAxios';
const prefix = '/marketplace';

export const useMarketPlaceGenerateLinkApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const marketPlaceGenerateLinkApi = async (data) => {
    return callApi(`${prefix}/generate-link`, data);
  };

  return { marketPlaceGenerateLinkApi, isLoading, isError, isSuccess };
};

export const useGetMarketPlaceCheckoutItemsApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const getMarketPlaceCheckoutItemsApi = async (data) => {
    return callApi(`${prefix}/checkout-items`, data);
  };

  return { getMarketPlaceCheckoutItemsApi, isLoading, isError, isSuccess };
};

export const useMarketPlaceCancelSubscriptionApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const marketPlaceCancelSubscriptionApi = async (data) => {
    return callApi(`${prefix}/cancel-subscription`, data);
  };

  return { marketPlaceCancelSubscriptionApi, isLoading, isError, isSuccess };
};

export const useMarketPlaceRemoveItemsApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const marketPlaceRemoveItemsApi = async (data) => {
    return callApi(`${prefix}/remove-item`, data);
  };

  return { marketPlaceRemoveItemsApi, isLoading, isError, isSuccess };
};
